import { getProjectById } from 'apis/project.api';
import { useQuery } from 'react-query';
import { useMemo } from 'react';

const useGetProjectById = (id, conds = {}) => {
  const { data: projectData, ...rest } = useQuery(['project', id], () => getProjectById(id), {
    ...conds,
  });

  const project = useMemo(() => projectData?.data ?? {}, [projectData]);

  return {
    data: project,
    ...rest,
  };
};

export default useGetProjectById;
